import { useEffect, useState } from "react";
import { Label, FileInput, Progress, Spinner } from "flowbite-react";
import {
  AiOutlineCheck,
  AiOutlineCloudUpload,
  AiOutlineClose,
} from "react-icons/ai";
import { IoClose } from "react-icons/io5";

const FileUploader = ({ label, onUpload, id, uploaded, rejectionReason }) => {
  const [status, setStatus] = useState("idle"); // idle | uploading | success | error

  useEffect(() => {
    if (uploaded) {
      setStatus("success");
    }
  }, [uploaded]);

  const handleChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setStatus("uploading");

    try {
      await onUpload(file);
      setStatus("success");
    } catch (err) {
      console.error(err);
      setStatus("error");
    }
  };

  const renderStatusIcon = () => {
    switch (status) {
      case "uploading":
        return <Spinner size="sm" className="mb-2" />;
      case "success":
        return <AiOutlineCheck className="text-green-500 text-lg" />;
      case "error":
        return <AiOutlineClose className="text-red-500 text-lg" />;
      default:
        return <AiOutlineCloudUpload />;
    }
  };

  const getBorderColor = () => {
    if (!rejectionReason) {
      switch (status) {
        case "success":
          return "border-green-500";
        case "error":
          return "border-red-500";
        default:
          return "border-gray-300";
      }
    }
    return "border-red-500";
  };

  const getTextColor = () => {
    switch (status) {
      case "success":
        return "text-green-600 dark:text-green-400";
      case "error":
        return "text-red-600 dark:text-red-400";
      default:
        return "text-gray-500 dark:text-gray-400";
    }
  };

  console.log(rejectionReason)

  return (
    <div className="flex w-full items-center justify-center">
      <Label
        htmlFor={id}
        className={`flex w-full cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed ${getBorderColor()} 
          bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:hover:border-gray-500 dark:hover:bg-gray-600`}
      >
        <div
          className="flex flex-col items-center justify-center pb-2 pt-2 px-2"
          style={{ minHeight: "130px" }}
        >
          {!rejectionReason ? (
            <div className={`${getTextColor()} h-10 text-xl`}>
              {renderStatusIcon()}
            </div>
          ) : (
            <div className={`text-red-500 h-10 text-xl`}>
              <IoClose />
            </div>
          )}
          {!rejectionReason ? (
            <>
              {" "}
              <p className={`text-sm ${getTextColor()} -mt-4 text-center`}>
                <span
                  className={`block text-center text-xs font-bold underline ${getTextColor()}`}
                >
                  {label}
                </span>
                <span className="font-semibold block text-center text-xs mt-1">
                  Clique para fazer o upload
                </span>
              </p>
              <p className={`text-2xs ${getTextColor()}`}>PNG, JPG ou PDF</p>
            </>
          ) : (
            <>
              {" "}
              <p className={`text-sm text-red-500 -mt-4 text-center`}>
                <span
                  className={`block text-center text-xs font-bold underline text-red-500`}
                >
                  {label}
                </span>
                <span className="font-semibold block text-center text-xs mt-1">
                  Rejeitado: {rejectionReason}
                </span>
                <span className="text-xs">
                  Necessário subir outro documento
                </span>
              </p>
            </>
          )}
        </div>
        <FileInput id={id} className="hidden" onChange={handleChange} />
      </Label>
    </div>
  );
};

export default FileUploader;
